<template>
  <v-main>
    <v-container fluid>
      <v-row justify="center">
        <v-col cols="12" md="8" lg="6">
          <v-card elevation="3" rounded="xxl" class="pa-4">
            <v-card-title class="font-weight-bold">
              Delete Account Request
            </v-card-title>
            <v-card-subtitle>
              Submit a request to delete your account. Our team will review and
              process it within 48 hours.
            </v-card-subtitle>

            <!-- Success state -->
            <v-card-text v-if="submitted" class="text-center py-8">
              <v-avatar color="success" size="80" class="mb-4">
                <v-icon color="white" size="40">mdi-check</v-icon>
              </v-avatar>
              <h2 class="text-h5 mb-2">Request Submitted</h2>
              <p class="text-body-1 mb-6">
                Your account deletion request has been submitted successfully.
                Our team will review and process it within 48 hours.
              </p>
              <v-btn color="primary" to="/login">Back to Login</v-btn>
            </v-card-text>

            <!-- Form -->
            <v-card-text v-else>
              <v-alert
                v-if="errorMessage"
                type="error"
                dismissible
                class="mb-4"
                @input="errorMessage = ''"
              >
                {{ errorMessage }}
              </v-alert>

              <v-text-field
                v-model="form.name"
                outlined
                label="Full Name *"
                prepend-inner-icon="mdi-account"
                :error-messages="errors.name"
              ></v-text-field>

              <v-text-field
                v-model="form.email"
                outlined
                label="Email"
                type="email"
                prepend-inner-icon="mdi-email"
                :error-messages="errors.email"
              ></v-text-field>

              <v-text-field
                v-model="form.phone"
                outlined
                label="Phone Number"
                prepend-inner-icon="mdi-phone"
                :error-messages="errors.phone"
              ></v-text-field>

              <v-textarea
                v-model="form.reason"
                outlined
                label="Reason for Deletion (Optional)"
                rows="3"
                prepend-inner-icon="mdi-comment-text-outline"
              ></v-textarea>

              <v-btn
                :loading="isLoading"
                rounded
                color="error"
                dark
                block
                large
                @click="save"
              >
                Submit Delete Request
              </v-btn>

              <div class="text-center mt-4">
                <router-link to="/login" class="text-decoration-none">
                  Back to Login
                </router-link>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "DeleteAccountRequestPage",
  data() {
    return {
      form: {
        name: "",
        email: "",
        phone: "",
        reason: "",
      },
      errors: {},
      errorMessage: "",
      isLoading: false,
      submitted: false,
    };
  },
  methods: {
    async save() {
      this.errors = {};
      this.errorMessage = "";

      if (!this.form.name) {
        this.errors.name = "Name is required";
        return;
      }
      if (!this.form.email && !this.form.phone) {
        this.errorMessage = "Please provide email or phone number";
        return;
      }

      try {
        this.isLoading = true;
        await axios.post("/account_delete_request", this.form);
        this.submitted = true;
      } catch (e) {
        const data = e.response && e.response.data;
        if (data && data.errors) {
          this.errors = data.errors;
        }
        this.errorMessage =
          (data && (data.message || data["sub-title"])) ||
          "Something went wrong. Please try again.";
      }
      this.isLoading = false;
    },
  },
};
</script>
